import { render, staticRenderFns } from "./AvailabilityExclusionSettings.vue?vue&type=template&id=4c200646&scoped=true&"
import script from "./AvailabilityExclusionSettings.vue?vue&type=script&lang=ts&"
export * from "./AvailabilityExclusionSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c200646",
  null
  
)

export default component.exports